import "core-js/modules/es.array.push.js";
import { defineComponent, defineAsyncComponent, ref, computed, watch, provide, onMounted } from 'vue';
import axios from "axios";
import { api } from "@/api/api";
import { useStore } from 'vuex';
import router from '@/router';
export default {
  name: 'member_science',
  setup() {
    const store = useStore(); // 该方法用于返回store 实例
    // tab栏目
    const tabList = ref([{
      name: '正畸',
      key: 'zhengji'
    }, {
      name: '种植',
      key: 'zhongzhi'
    }, {
      name: '修复',
      key: 'xiufu'
    }, {
      name: '综合',
      key: 'zonghe'
    }, {
      name: '肌功能',
      key: 'jigongneng'
    }, {
      name: '儿牙',
      key: 'erya'
    }]);
    // 当前选中的tab
    const tabIndex = ref(0);
    // 展示信息
    const get_data = ref({});
    // 当前选中的展示信息
    const select_index = ref(0);
    // 获取信息
    const get_text = () => {
      let url = api.baseUrl + api.text + '?category=science&category2=' + tabList.value[tabIndex.value].key + '&isNotes=0';
      axios({
        url,
        method: 'get'
      }).then(res => {
        // console.log(res);
        get_data.value.top = res.data.rows;
      });
    };
    // 获取底部注意事项
    const get_attention = () => {
      let url = api.baseUrl + api.text + '?category=science&category2=' + tabList.value[tabIndex.value].key + '&isNotes=1';
      axios({
        url,
        method: 'get'
      }).then(res => {
        console.log(res);
        get_data.value.boot = res.data.rows;
      });
    };
    // 顶部新闻切换事件
    const info_option = e => {
      select_index.value = e;
    };
    // tab点击事件
    const tabClick = e => {
      if (tabIndex.value != e) {
        tabIndex.value = e;
        get_text();
        get_attention();
      }
    };
    // 查看图文详情
    const details = (e, index) => {
      if (index <= 2) {
        router.push({
          name: 'member_details',
          params: {
            id: e
          }
        });
      } else {
        // 判断有没有登录
        if (!localStorage.getItem('userData')) {
          show();
        } else {
          const user_info = ref(JSON.parse(localStorage.getItem('userData')));
          if (user_info.value.spent != '1') {
            show();
          } else {
            router.push({
              name: 'member_details',
              params: {
                id: e
              }
            });
          }
        }
      }
    };
    // 联系我们
    const call = () => {
      store.commit('serviceShow', true);
    };
    // 查看更多
    const more = () => {
      router.push({
        name: 'member_science_more'
      });
    };
    get_text();
    get_attention();
    return {
      tabList,
      tabIndex,
      get_text,
      tabClick,
      get_attention,
      get_data,
      select_index,
      info_option,
      details,
      call,
      more
    };
  }
};